module.exports = __webpack_public_path__ + "static/img/yujing.2fc479c8.png";